import { render } from "./RentenClearUpErklaerVideoNew.vue?vue&type=template&id=781db57a"
import script from "./RentenClearUpErklaerVideoNew.vue?vue&type=script&lang=js"
export * from "./RentenClearUpErklaerVideoNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__